module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"เพิ่มข้อมูลอะไหล่","page.description":"เพิ่มข้อมูลอะไหล่ที่ใช้งานกับ Drone ในระบบ","create_part.success":"ทำการเพิ่มอะไหล่ \\"SKU : {name}\\" ในระบบเรียบร้อย","create_part.submit.label":"เพิ่มอะไหล่","create_part.confirm.title":"ยืนยันเพิ่มอะไหล่","create_part.confirm.message":"คุณต้องการเพิ่มอะไหล่นี้เข้าระบบ ?"}}')
  delete Component.options._Ctor
}
